import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { fabric } from 'fabric';
import styles from "./index.module.scss"
import * as _ from "underscore";
import eventBus from '@utils/eventBus';
import { forwardRef, useImperativeHandle } from "react"

const formartNumber = (number, digits = 2) => {
    return Number(number.toFixed(digits))
}
// const imgCursor = encodeURIComponent(`
//   <svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='24' height='24'>
//     <defs>
//       <filter id='a' width='266.7%' height='156.2%' x='-75%' y='-21.9%' filterUnits='objectBoundingBox'>
//         <feOffset dy='1' in='SourceAlpha' result='shadowOffsetOuter1'/>
//         <feGaussianBlur in='shadowOffsetOuter1' result='shadowBlurOuter1' stdDeviation='1'/>
//         <feColorMatrix in='shadowBlurOuter1' result='shadowMatrixOuter1' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0'/>
//         <feMerge>
//           <feMergeNode in='shadowMatrixOuter1'/>
//           <feMergeNode in='SourceGraphic'/>
//         </feMerge>
//       </filter>
//       <path id='b' d='M1.67 12.67a7.7 7.7 0 0 0 0-9.34L0 5V0h5L3.24 1.76a9.9 9.9 0 0 1 0 12.48L5 16H0v-5l1.67 1.67z'/>
//     </defs>
//     <g fill='none' fillRule='evenodd'><path d='M0 24V0h24v24z'/>
//       <g fillRule='nonzero' filter='url(#a)' transform='rotate(-90 9.25 5.25)'>
//         <use fill='#000' fillRule='evenodd' xlink:href='#b'/>
//         <path stroke='#FFF' d='M1.6 11.9a7.21 7.21 0 0 0 0-7.8L-.5 6.2V-.5h6.7L3.9 1.8a10.4 10.4 0 0 1 0 12.4l2.3 2.3H-.5V9.8l2.1 2.1z'/>
//       </g>
//     </g>
//   </svg>`);

// const svgRotateIcon = encodeURIComponent(`
// <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
//   <g filter="url(#filter0_d)">
//     <circle cx="9" cy="9" r="5" fill="white"/>
//     <circle cx="9" cy="9" r="4.75" stroke="black" stroke-opacity="0.3" strokeWidth="0.5"/>
//   </g>
//     <path d="M10.8047 11.1242L9.49934 11.1242L9.49934 9.81885" stroke="black" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round"/>
//     <path d="M6.94856 6.72607L8.25391 6.72607L8.25391 8.03142" stroke="black" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round"/>
//     <path d="M9.69517 6.92267C10.007 7.03301 10.2858 7.22054 10.5055 7.46776C10.7252 7.71497 10.8787 8.01382 10.9517 8.33642C11.0247 8.65902 11.0148 8.99485 10.9229 9.31258C10.831 9.63031 10.6601 9.91958 10.4262 10.1534L9.49701 11.0421M8.25792 6.72607L7.30937 7.73554C7.07543 7.96936 6.90454 8.25863 6.81264 8.57636C6.72073 8.89408 6.71081 9.22992 6.78381 9.55251C6.8568 9.87511 7.01032 10.174 7.23005 10.4212C7.44978 10.6684 7.72855 10.8559 8.04036 10.9663" stroke="black" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round"/>
//   <defs>
//   <filter id="filter0_d" x="0" y="0" width="18" height="18" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
//     <feFlood flood-opacity="0" result="BackgroundImageFix"/>
//     <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
//     <feOffset/>
//     <feGaussianBlur stdDeviation="2"/>
//     <feColorMatrix type="matrix" values="0 0 0 0 0.137674 0 0 0 0 0.190937 0 0 0 0 0.270833 0 0 0 0.15 0"/>
//     <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
//     <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
//   </filter>
//   </defs>
// </svg>`)
// const rotateIcon = `data:image/svg+xml;utf8,${svgRotateIcon}`
// const imgIcon = document.createElement('img');
// imgIcon.src = rotateIcon;

// Changing rotation control properties
// fabric.Object.prototype.controls.mtr = new fabric.Control({
//     x: 0,
//     y: -0.5,
//     offsetX: 0,
//     offsetY: -40,
//     cursorStyle: `url("data:image/svg+xml;charset=utf-8,${imgCursor}") 12 12, crosshair`,
//     actionHandler: fabric.controlsUtils.rotationWithSnapping,
//     actionName: 'rotate',
//     render: renderIcon,
//     cornerSize: 38,
//     withConnection: true
// });

// Defining how the rendering action will be
// function renderIcon(ctx, left, top, styleOverride, fabricObject) {
//     var size = this.cornerSize;
//     ctx.save();
//     ctx.translate(left, top);
//     ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
//     ctx.drawImage(imgIcon, -size / 2, -size / 2, size, size);
//     ctx.restore();
// };

const LabelBox2 = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        handleUndo,
        handleReset
    }))
    const fabricObjParams = {
        fill: "transparent",
        perPixelTargetFind: true,
        transparentCorners: false, // 透明控制角
        cornerColor: "#3572FF", // 控制角颜色
        cornerStrokeColor: "#FFFFFF", // 控制角边框颜色
        cornerSize: 10, // 控制角大小
        cornerStyle: "circle", // 控制角形状
        borderScaleFactor: 2, // 辅助边粗细
        borderColor: '#3572FF', // 辅助边颜色
        borderOpacityWhenMoving: .2
    }

    // 编辑模式
    const stroke = 'rgba(255, 0, 0, 1)'
    const strokeAlpha = 'rgba(255, 0, 0, .3)'
    // 编辑模式
    const modeRef = useRef(props.mode)
    useEffect(() => {
        modeRef.current = props.mode
    }, [props.mode])
    // 画笔宽度
    const strokeWidthRef = useRef()
    const strokeWidth = useMemo(() => {
        return (props.width / 512) * 4
    }, [props.width])
    useEffect(() => {
        strokeWidthRef.current = strokeWidth
        if (fabricInstanceRef.current) fabricInstanceRef.current.freeDrawingBrush.width = strokeWidthRef.current
    }, [strokeWidth])
    // 字体
    const fontSizeRef = useRef()
    const fontSize = useMemo(() => {
        return (props.width / 512) * 24
    }, [props.width])
    useEffect(() => {
        fontSizeRef.current = fontSize
    }, [fontSize])

    // 绘制矩形
    const downPointRef = useRef()
    const upPointRef = useRef()
    const currentRectRef = useRef()
    const handleMouseDownRect = ev => {
        const downPoint = ev.absolutePointer
        const rect = new fabric.Rect({
            left: downPoint.x,
            top: downPoint.y,
            width: 0,
            height: 0,
            stroke: strokeAlpha,
            strokeWidth: strokeWidthRef.current,
            ...fabricObjParams,
        })
        rect.setControlsVisibility({
            mt: false, // 隐藏上边中心点
            mb: false, // 隐藏下边中心点
            ml: false, // 隐藏左边中心点
            mr: false, // 隐藏右边中心点
            mtr: false // 隐藏旋转点
        })
        currentRectRef.current = rect
        downPointRef.current = downPoint
        fabricInstanceRef.current.add(currentRectRef.current)
    }
    const handleMouseMoveRect = ev => {
        if (!downPointRef.current) return
        if (!currentRectRef.current) return
        const currentPoint = ev.absolutePointer
        const downPoint = downPointRef.current
        currentRectRef.current.set({
            left: Math.min(downPoint.x, currentPoint.x),
            top: Math.min(downPoint.y, currentPoint.y),
            width: Math.abs(downPoint.x - currentPoint.x),
            height: Math.abs(downPoint.y - currentPoint.y),
        })
        fabricInstanceRef.current.requestRenderAll()
    }
    const handleMouseUpRect = ev => {
        if (!downPointRef.current) return
        if (!currentRectRef.current) return
        const upPoint = ev.absolutePointer
        const downPoint = downPointRef.current
        if (JSON.stringify(downPoint) === JSON.stringify(upPoint)) {
            fabricInstanceRef.current.remove(currentRectRef.current)
            // 更新标注
            handleSaveDebounce()
        } else {
            currentRectRef.current.set("stroke", stroke)
            fabricInstanceRef.current.requestRenderAll()
            // 缓存撤销
            handleAddUndo('handleMouseUpRect')
            // 更新标注
            handleSaveDebounce()
        }
        downPointRef.current = null
        upPointRef.current = null
        currentRectRef.current = null
    }

    // 绘制椭圆
    const currentEllipseRef = useRef()
    const handleMouseDownEllipse = ev => {
        const downPoint = ev.absolutePointer
        const ellipse = new fabric.Ellipse({
            left: downPoint.x,
            top: downPoint.y,
            rx: 0,
            ry: 0,
            stroke: strokeAlpha,
            strokeWidth: strokeWidthRef.current,
            ...fabricObjParams,
        })
        ellipse.setControlsVisibility({
            mt: false, // 隐藏上边中心点
            mb: false, // 隐藏下边中心点
            ml: false, // 隐藏左边中心点
            mr: false, // 隐藏右边中心点
            mtr: false // 隐藏旋转点
        })
        currentEllipseRef.current = ellipse
        downPointRef.current = downPoint
        fabricInstanceRef.current.add(currentEllipseRef.current)
    }
    const handleMouseMoveEllipse = ev => {
        if (!downPointRef.current) return
        if (!currentEllipseRef.current) return
        const currentPoint = ev.absolutePointer
        const downPoint = downPointRef.current
        const rx = Math.abs(downPoint.x - currentPoint.x) / 2
        const ry = Math.abs(downPoint.y - currentPoint.y) / 2
        const top = currentPoint.y > downPoint.y ? downPoint.y : downPoint.y - ry * 2
        const left = currentPoint.x > downPoint.x ? downPoint.x : downPoint.x - rx * 2
        // 设置椭圆尺寸和所在位置
        currentEllipseRef.current.set({
            left: left,
            top: top,
            rx: rx,
            ry: ry,
        })
        fabricInstanceRef.current.requestRenderAll()
    }
    const handleMouseUpEllipse = ev => {
        if (!downPointRef.current) return
        if (!currentEllipseRef.current) return
        const upPoint = ev.absolutePointer
        const downPoint = downPointRef.current
        if (JSON.stringify(downPoint) === JSON.stringify(upPoint)) {
            fabricInstanceRef.current.remove(currentEllipseRef.current)
            // 更新标注
            handleSaveDebounce()
        } else {
            currentEllipseRef.current.set("stroke", stroke)
            fabricInstanceRef.current.requestRenderAll()
            // 缓存撤销
            handleAddUndo('handleMouseUpEllipse')
            // 更新标注
            handleSaveDebounce()
        }
        downPointRef.current = null
        upPointRef.current = null
        currentEllipseRef.current = null
    }

    // 箭头
    const currentArrowRef = useRef()
    function calcArrowAngle(x1, y1, x2, y2) {
        let angle = 0, x, y;
        x = (x2 - x1);
        y = (y2 - y1);
        if (x === 0) {
            angle = (y === 0) ? 0 : (y > 0) ? Math.PI / 2 : Math.PI * 3 / 2;
        } else if (y === 0) {
            angle = (x > 0) ? 0 : Math.PI;
        } else {
            angle = (x < 0) ? Math.atan(y / x) + Math.PI : (y < 0) ? Math.atan(y / x) + (2 * Math.PI) : Math.atan(y / x);
        }
        return (angle * 180 / Math.PI);
    }
    function arrowLinePath(x1, y1, x2, y2) {
        const dis = Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2))
        const arrowSize1 = Math.min(20, dis / 4)
        const arrowSize2 = arrowSize1 * 0.7
        const arrowSize3 = arrowSize1 * 0.3
        const point1 = [dis, 0]
        const point2 = [point1[0] - arrowSize1, point1[1] - arrowSize2]
        const point3 = [point1[0] - arrowSize1, point1[1] + arrowSize2]
        const point4 = [point1[0] - arrowSize1, point1[1] - arrowSize3]
        const point5 = [point1[0] - arrowSize1, point1[1] + arrowSize3]
        return `
            M 0 0
            L ${point4[0]} ${point4[1]}
            L ${point2[0]} ${point2[1]}
            L ${point1[0]} ${point1[1]}
            L ${point3[0]} ${point3[1]}
            L ${point5[0]} ${point5[1]}
            z
        `
    }
    const handleMouseDownArrow = ev => {
        const downPoint = ev.absolutePointer
        const x1 = downPoint.x
        const y1 = downPoint.y
        const x2 = downPoint.x
        const y2 = downPoint.y
        const path = new fabric.Path(arrowLinePath(x1, y1, x2, y2), {
            originX: 'left',
            originY: 'center',
            ...fabricObjParams,
            fill: stroke,
        })
        const angle = calcArrowAngle(x1, y1, x2, y2)
        path.set({
            angle: angle,
            left: downPoint.x,
            top: downPoint.y,
            isArrow: true
        })
        path.setControlsVisibility({
            mt: false, // 隐藏上边中心点
            mb: false, // 隐藏下边中心点
            ml: false, // 隐藏左边中心点
            mr: false, // 隐藏右边中心点
            mtr: false // 隐藏旋转点
        })
        downPointRef.current = downPoint
        currentArrowRef.current = path
        fabricInstanceRef.current.add(path);
    }
    const handleMouseMoveArrow = ev => {
        if (!downPointRef.current) return
        if (!currentArrowRef.current) return
        const path = currentArrowRef.current
        const currentPoint = ev.absolutePointer
        const downPoint = downPointRef.current
        const x1 = downPoint.x
        const y1 = downPoint.y
        const x2 = currentPoint.x
        const y2 = currentPoint.y
        const updatedPath = new fabric.Path(arrowLinePath(x1, y1, x2, y2))
        const updateAngle = calcArrowAngle(x1, y1, x2, y2)
        path.set({
            path: updatedPath.path,
            width: updatedPath.width,
            height: updatedPath.height,
            pathOffset: updatedPath.pathOffset
        })
        path.set({ angle: updateAngle })
        path.setCoords()
        fabricInstanceRef.current.requestRenderAll()
    }
    const handleMouseUpArrow = ev => {
        if (!downPointRef.current) return
        if (!currentArrowRef.current) return
        const upPoint = ev.absolutePointer
        const downPoint = downPointRef.current

        if (JSON.stringify(downPoint) === JSON.stringify(upPoint)) {
            fabricInstanceRef.current.remove(currentArrowRef.current)
            // 更新标注
            handleSaveDebounce()
        } else {
            currentArrowRef.current.set("fill", stroke)
            fabricInstanceRef.current.requestRenderAll()
            // 缓存撤销
            handleAddUndo('handleMouseUpArrow')
            // 更新标注
            handleSaveDebounce()
        }
        downPointRef.current = null
        upPointRef.current = null
        currentArrowRef.current = null
    }

    // 输入框
    const currentTextRef = useRef()
    const handleMouseDownText = (ev) => {
        const downPoint = ev.absolutePointer
        const iText = new fabric.IText('', {
            left: downPoint.x, // 输入框离画布左侧距离
            top: downPoint.y, // 输入框离画布顶部距离
            padding: 7, // 设置输入框内边距
            fontSize: fontSizeRef.current,
            ...fabricObjParams,
            fill: stroke,
            perPixelTargetFind: false,
        })
        iText.setControlsVisibility({
            mt: false, // 隐藏上边中心点
            mb: false, // 隐藏下边中心点
            ml: false, // 隐藏左边中心点
            mr: false, // 隐藏右边中心点
            mtr: false // 隐藏旋转点
        })
        addEventToIText(iText)
        fabricInstanceRef.current.add(iText).setActiveObject(iText)
        iText.enterEditing()
    }
    const addEventToIText = (iText) => {
        iText.on('editing:entered', () => {
            currentTextRef.current = iText
        })
        iText.on('changed', () => {
            // 更新标注
            handleSaveDebounce()
        })
        iText.on('editing:exited', () => {
            if (!currentTextRef.current) return
            const obj = currentTextRef.current
            if (!obj.text) {
                fabricInstanceRef.current.remove(obj)
                // 更新标注
                handleSaveDebounce()
            } else {
                // 缓存撤销
                handleAddUndo('editing:exited')
                // 更新标注
                handleSaveDebounce()
            }
            currentTextRef.current = null
        })
    }

    const handleMouseDown = (ev) => {
        const target = ev.target
        if (target) return
        if (modeRef.current == "rect") {
            handleMouseDownRect(ev)
        } else if (modeRef.current == "ellipse") {
            handleMouseDownEllipse(ev)
        } else if (modeRef.current == "text") {
            handleMouseDownText(ev)
        } else if (modeRef.current == "arrow") {
            handleMouseDownArrow(ev)
        }
        const objs = fabricInstanceRef.current.getObjects()
        objs.forEach(obj => obj.selectable = false)
        fabricInstanceRef.current.renderAll()
    }
    const handleMouseMove = (ev) => {
        if (modeRef.current == "rect") {
            handleMouseMoveRect(ev)
        } else if (modeRef.current == "ellipse") {
            handleMouseMoveEllipse(ev)
        } else if (modeRef.current == "arrow") {
            handleMouseMoveArrow(ev)
        }
    }
    const handleMouseUp = (ev) => {
        if (modeRef.current == "rect") {
            handleMouseUpRect(ev)
        } else if (modeRef.current == "ellipse") {
            handleMouseUpEllipse(ev)
        } else if (modeRef.current == "arrow") {
            handleMouseUpArrow(ev)
        }
        const objs = fabricInstanceRef.current.getObjects()
        objs.forEach(obj => { obj.selectable = true; obj.setCoords(); })
        fabricInstanceRef.current.renderAll()
        // 更新标注
        handleSaveDebounce()
    }
    const handlePathCreated = ({ path }) => {
        path.set({ ...fabricObjParams })
        path.setControlsVisibility({
            mt: false, // 隐藏上边中心点
            mb: false, // 隐藏下边中心点
            ml: false, // 隐藏左边中心点
            mr: false, // 隐藏右边中心点
            mtr: false // 隐藏旋转点
        })
        // 缓存撤销
        handleAddUndo('handlePathCreated')
        // 更新标注
        handleSaveDebounce()
    }

    const getTags = () => {
        if (!fabricInstanceRef.current) return []
        const canvasWidth = fabricInstanceRef.current.width
        const canvasHeight = fabricInstanceRef.current.height
        const objs = fabricInstanceRef.current.getObjects()
        const tags = objs.map(obj => {
            return {
                type: obj.type,
                json: JSON.stringify(obj.toJSON(['isArrow'])),
                canvasWidth: canvasWidth,
                canvasHeight: canvasHeight,
            }
        })
        return tags
    }
    const handleSaveDebounce = useCallback(_.debounce(() => {
        const tags = getTags()
        props.onLabelChange(tags)
    }, 300), [])
    const loadData = (instance, readonly, data) => {
        if (data.length == 0) return Promise.resolve(true)
        return new Promise(resolve => {
            const canvasWidth = data[0].canvasWidth
            const canvasHeight = data[0].canvasHeight
            const width = instance.width
            const height = instance.height
            const canvasScaleX = width / canvasWidth
            const canvasScaleY = height / canvasHeight
            fabric.util.enlivenObjects(data.filter(item => item.json)
                .map(item => JSON.parse(item.json))
                .filter(item => {
                    if (item.type == 'i-text') return ("text" in item)
                    else return true
                }), objs => {
                objs.forEach(item => {                    
                    if (item.type == 'i-text') {
                        item.set({
                            ...fabricObjParams,
                            fill: stroke,
                            perPixelTargetFind: false,
                            selectable: !readonly
                        })
                        addEventToIText(item)
                    } else if (item.type == 'path') {
                        if (item.get("isArrow")) {
                            item.set({
                                ...fabricObjParams,
                                fill: stroke,
                                selectable: !readonly
                            })
                        } else {
                            item.set({
                                ...fabricObjParams,
                                selectable: !readonly
                            })
                        }
                    } else {
                        item.set({
                            ...fabricObjParams,
                            selectable: !readonly
                        })
                    }
                    item.setControlsVisibility({
                        mt: false, // 隐藏上边中心点
                        mb: false, // 隐藏下边中心点
                        ml: false, // 隐藏左边中心点
                        mr: false, // 隐藏右边中心点
                        mtr: false // 隐藏旋转点
                    })
                })
                objs.forEach(item => {
                    if (item.type == 'path') {
                        item.scale(item.scaleX * canvasScaleX)
                        item.set({
                            left: formartNumber(item.left * canvasScaleX),
                            top: formartNumber(item.top * canvasScaleY),
                        })
                    } else if (item.type == "ellipse") {
                        item.set({
                            left: formartNumber(item.left * canvasScaleX),
                            top: formartNumber(item.top * canvasScaleY),
                            rx: formartNumber(item.rx * canvasScaleX),
                            ry: formartNumber(item.ry * canvasScaleY),
                        })
                    } else if (item.type == "i-text") {
                        item.set({fontSize: item.fontSize * canvasScaleX})
                        item.set({
                            width: formartNumber(item.width * canvasScaleX),
                            height: formartNumber(item.height * canvasScaleX),
                            left: formartNumber(item.left * canvasScaleX),
                            top: formartNumber(item.top * canvasScaleY),
                        })
                    } else {
                        item.set({
                            width: formartNumber(item.width * canvasScaleX),
                            height: formartNumber(item.height * canvasScaleX),
                            left: formartNumber(item.left * canvasScaleX),
                            top: formartNumber(item.top * canvasScaleY),
                        })
                    }
                    item.setCoords()
                })
                instance.add(...objs)
                instance.renderAll()
                resolve(true)
            })
        })
    }
    // 快捷键
    const undoListRef = useRef([])
    const [undoList, setUndoList] = useState([])
    const handleKeyDown = (e) => {
        if (props.readonly) return
        if (!fabricInstanceRef.current) return
        if (e.ctrlKey && e.key.toLocaleLowerCase() == "a") { // 全选
            // 阻止事件冒泡
            if (e.stopPropagation) e.stopPropagation();
            else e.cancelBubble = true;
            // 取消事件默认行为
            if(e.preventDefault) e.preventDefault();
            else e.returnValue = false;
        } else if (e.ctrlKey && e.key.toLocaleLowerCase() == "z") { // ctrl+z 撤销
            handleUndo()
        } else if (e.key == "Delete") { // 删除
            const obj = fabricInstanceRef.current.getActiveObject()
            if (obj) {
                if (obj.type == "activeSelection") {
                    fabricInstanceRef.current.clear()
                } else {
                    fabricInstanceRef.current.FX_DURATION = 100 // 设置动画时长，默认500毫秒
                    fabricInstanceRef.current.fxRemove(obj, {
                        onComplete: () => {
                            // 缓存撤销
                            handleAddUndo('handleKeyDownDelete')
                            // 更新标注
                            handleSaveDebounce()
                        }
                    })
                }
            }
        }
    }
    const handleUndo = () => {
        if (!fabricInstanceRef.current) return
        // 清除当前正在操作的数据
        downPointRef.current = null
        upPointRef.current = null
        currentRectRef.current = null
        currentArrowRef.current = null
        currentEllipseRef.current = null
        currentTextRef.current = null
        
        undoListRef.current.pop() // 丢弃当前
        const tags = undoListRef.current.at(-1) // 取前一个场景
        setUndoList(undoListRef.current)
        if (tags) {
            fabricInstanceRef.current.clear()
            loadData(fabricInstanceRef.current, props.readonly, tags).then(() => {
                // 更新标注
                handleSaveDebounce()
            })
        } else {
            const objs = fabricInstanceRef.current.getObjects()
            const obj = objs.pop()
            if (obj) {
                fabricInstanceRef.current.FX_DURATION = 100 // 设置动画时长，默认500毫秒
                fabricInstanceRef.current.fxRemove(obj, {
                    onComplete: () => {
                        // 更新标注
                        handleSaveDebounce()
                    }
                })
            }
        }
    }
    const handleReset = () => {
        if (!fabricInstanceRef.current) return
        undoListRef.current = []
        setUndoList(undoListRef.current)
        fabricInstanceRef.current.clear()
        // 更新标注
        handleSaveDebounce()
    }
    // const handleObjectModified = () => {
    //     // 缓存撤销
    //     handleAddUndo('handleObjectModified')
    // }
    const handleObjectMove = useCallback(_.debounce(() => {
        // 缓存撤销
        handleAddUndo('handleObjectMove')
        // 更新标注
        handleSaveDebounce()
    }, 200), [])
    const handleObjectScale = useCallback(_.debounce(() => {
        // 缓存撤销
        handleAddUndo('handleObjectScale')
        // 更新标注
        handleSaveDebounce()
    }, 200), [])
    const handleAddUndo = (from) => {
        console.log('AddUndo', from)
        const tags = getTags()
        undoListRef.current.push(tags)
        setUndoList(undoListRef.current)
    }

    const canvasRef = useRef()
    const [fabricInstance, setFabricInstance] = useState()
    const fabricInstanceRef = useRef()
    useEffect(() => {
        const width = props.width
        const heigth = props.height
        const instance = new fabric.Canvas(canvasRef.current, {
            width: width,
            height: heigth,
            fireRightClick: false, // 启用右键
            stopContextMenu: true, // 禁用右键菜单
            isDrawingMode: false, // 禁用绘图模式
            selectionBorderColor: "transparent", // rgba(255, 255, 255, 0.3)
            selectionColor: "transparent", // rgba(100, 100, 255, 0.3)
        })
        instance.freeDrawingBrush.width = strokeWidthRef.current
        instance.freeDrawingBrush.color = stroke

        loadData(instance, props.readonly, props.labels??[]).then(res => {
            // 缓存撤销
            handleAddUndo('loadData')
        })

        if (!props.readonly) {
            instance.on('mouse:down', handleMouseDown)
            instance.on('mouse:move', handleMouseMove)
            instance.on('mouse:up', handleMouseUp)
            instance.on('path:created', handlePathCreated)
            // instance.on('after:render', handleSaveDebounce)
            // instance.on('object:modified', handleObjectModified)
            instance.on('object:moving', handleObjectMove) // 移动
            instance.on('object:scaling', handleObjectScale) // 缩放
        }

        fabricInstanceRef.current = instance
        setFabricInstance(instance)

        document.addEventListener("keydown", handleKeyDown)
        return () => {
            document.removeEventListener("keydown", handleKeyDown)
            fabricInstanceRef.current.dispose()
        }
    }, [])

    useEffect(() => {
        if (!fabricInstance) return
        if (!props.mode) {
            fabricInstance.discardActiveObject()
            fabricInstance.renderAll()
        }
        if (props.mode == 'brush') {
            fabricInstance.isDrawingMode = true
        } else {
            fabricInstance.isDrawingMode = false
        }
        if (props.mode == "rect") {
            fabricInstance.defaultCursor = "crosshair"
            fabricInstance.hoverCursor = "pointer"
        } else if (props.mode == "ellipse") {
            fabricInstance.defaultCursor = "crosshair"
            fabricInstance.hoverCursor = "pointer"
        } else if (props.mode == "brush") {
            fabricInstance.defaultCursor = "crosshair"
            fabricInstance.hoverCursor = "crosshair"
            fabricInstance.freeDrawingCursor = "crosshair"
        } else if (props.mode == "arrow") {
            fabricInstance.defaultCursor = "crosshair"
            fabricInstance.hoverCursor = "pointer"
        } else if (props.mode == "text") {
            fabricInstance.defaultCursor = "text"
            fabricInstance.hoverCursor = "pointer"
        } else {
            fabricInstance.defaultCursor = "pointer"
            fabricInstance.hoverCursor = "pointer"
        }
    }, [props.mode, fabricInstance])

    useEffect(() => {
        if (!fabricInstance) return
        const width = props.width
        const heigth = props.height

        const canvasScaleX = width / fabricInstance.width
        const canvasScaleY = heigth / fabricInstance.height

        fabricInstance.setDimensions({ width: width, height: heigth })

        const objs = fabricInstance.getObjects()
        objs.forEach(item => {
            if (item.type == 'path') {
                item.scale(item.scaleX * canvasScaleX)
                item.set({
                    left: formartNumber(item.left * canvasScaleX),
                    top: formartNumber(item.top * canvasScaleY),
                })
            } else if (item.type == "ellipse") {
                item.set({
                    left: formartNumber(item.left * canvasScaleX),
                    top: formartNumber(item.top * canvasScaleY),
                    rx: formartNumber(item.rx * canvasScaleX),
                    ry: formartNumber(item.ry * canvasScaleY),
                })
            } else if (item.type == "i-text") {
                item.set({fontSize: item.fontSize * canvasScaleX})
                item.set({
                    width: formartNumber(item.width * canvasScaleX),
                    height: formartNumber(item.height * canvasScaleX),
                    left: formartNumber(item.left * canvasScaleX),
                    top: formartNumber(item.top * canvasScaleY),
                })
            } else {
                item.set({
                    width: formartNumber(item.width * canvasScaleX),
                    height: formartNumber(item.height * canvasScaleX),
                    left: formartNumber(item.left * canvasScaleX),
                    top: formartNumber(item.top * canvasScaleY),
                })
            }
            item.setCoords()
        })
        fabricInstance.renderAll()
    }, [fabricInstance, props.width, props.height])

    useEffect(() => {
        if (!fabricInstance) return
        return () => {
            fabricInstance.off('mouse:down')
            fabricInstance.off('mouse:up')
        }
    }, [fabricInstance])

    return (
        <div
            className={`${styles.LabelBox} ${!props.mode && styles.pointerEventNone}`}
            style={props.style}
            onWheel={props.onWheel}
        >
            <canvas ref={canvasRef} />
        </div>
    )
})

export default LabelBox2